import React from 'react';

const UploadDownloadArrow = () => {

  return (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="50"
    height="50"
    viewBox="0 0 80 80" 
    fill="none"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M50.0001 29.9333H41.6001V51.6667C41.6001 51.7219 41.5973 51.7765 41.5918 51.8302C41.5099 52.6371 40.8285 53.2667 40.0001 53.2667H33.9771L50.8334 69.4487L67.6897 53.2667H61.6668C60.7831 53.2667 60.0668 52.5503 60.0668 51.6667V29.9333L50.0001 29.9333ZM29.3564 53.2667H18.3334C17.4498 53.2667 16.7334 52.5503 16.7334 51.6667V29.9333H8.33344C6.8922 29.9333 6.1857 28.1772 7.22539 27.1791L28.0587 7.17911C28.6779 6.58474 29.6557 6.58474 30.2748 7.17911L50.6438 26.7333H61.6668C62.5504 26.7333 63.2668 27.4497 63.2668 28.3333V50.0667H71.6668C73.108 50.0667 73.8145 51.8228 72.7748 52.8209L51.9415 72.8209C51.3223 73.4152 50.3445 73.4152 49.7254 72.8209L29.3564 53.2667ZM29.9964 50.0667H19.9334V28.3333C19.9334 27.4497 19.2171 26.7333 18.3334 26.7333H12.3105L29.1668 10.5513L46.0231 26.7333H40.0001C39.1164 26.7333 38.4001 27.4497 38.4001 28.3333V50.0667L30.0001 50.0667C29.9989 50.0667 29.9977 50.0667 29.9964 50.0667Z" 
      fill="#BD0000"
    />
    <mask
      id="mask0"
      mask-type="alpha"
      maskUnits="userSpaceOnUse"
      x="6"
      y="6"
      width="68"
      height="68"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M50.0001 29.9333H41.6001V51.6667C41.6001 51.7219 41.5973 51.7765 41.5918 51.8302C41.5099 52.6371 40.8285 53.2667 40.0001 53.2667H33.9771L50.8334 69.4487L67.6897 53.2667H61.6668C60.7831 53.2667 60.0668 52.5503 60.0668 51.6667V29.9333L50.0001 29.9333ZM29.3564 53.2667H18.3334C17.4498 53.2667 16.7334 52.5503 16.7334 51.6667V29.9333H8.33344C6.8922 29.9333 6.1857 28.1772 7.22539 27.1791L28.0587 7.17911C28.6779 6.58474 29.6557 6.58474 30.2748 7.17911L50.6438 26.7333H61.6668C62.5504 26.7333 63.2668 27.4497 63.2668 28.3333V50.0667H71.6668C73.108 50.0667 73.8145 51.8228 72.7748 52.8209L51.9415 72.8209C51.3223 73.4152 50.3445 73.4152 49.7254 72.8209L29.3564 53.2667ZM29.9964 50.0667H19.9334V28.3333C19.9334 27.4497 19.2171 26.7333 18.3334 26.7333H12.3105L29.1668 10.5513L46.0231 26.7333H40.0001C39.1164 26.7333 38.4001 27.4497 38.4001 28.3333V50.0667L30.0001 50.0667C29.9989 50.0667 29.9977 50.0667 29.9964 50.0667Z" 
        fill="white"
      />
    </mask>
    <g mask="url(#mask0)">
      <rect
        width="80" 
        height="80" 
        fill="#BD0000"
      />
    </g>
  </svg>
  )
}

export default UploadDownloadArrow;